import { createContext, useContext, useState, useEffect } from 'react';

const CompanySettingsContext = createContext();

export const useCompanySettings = () => {
  const context = useContext(CompanySettingsContext);
  if (!context) {
    throw new Error('useCompanySettings must be used within a CompanySettingsProvider');
  }
  return context;
};

export const CompanySettingsProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState(() => {
    return localStorage.getItem('esg_company_name') || 'Demo Company Ltd.';
  });
  
  const [industry, setIndustry] = useState(() => {
    return localStorage.getItem('esg_industry') || 'office';
  });
  
  const [logoUrl, setLogoUrl] = useState(() => {
    return localStorage.getItem('esg_logo_url') || '';
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem('esg_company_name', companyName);
  }, [companyName]);

  useEffect(() => {
    localStorage.setItem('esg_industry', industry);
  }, [industry]);

  useEffect(() => {
    localStorage.setItem('esg_logo_url', logoUrl);
  }, [logoUrl]);

  const value = {
    companyName,
    setCompanyName,
    industry,
    setIndustry,
    logoUrl,
    setLogoUrl
  };

  return (
    <CompanySettingsContext.Provider value={value}>
      {children}
    </CompanySettingsContext.Provider>
  );
};

export default CompanySettingsContext;
